/**
 * @generated SignedSource<<5ffdf24c1be5ce90087f8e69bf761dcd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addAIVirtualModelRulePanel_AIVirtualModelRulesListQuery$variables = Record<PropertyKey, never>;
export type addAIVirtualModelRulePanel_AIVirtualModelRulesListQuery$data = {
  readonly aiVirtualModelRules: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly ruleID: number;
  }>;
};
export type addAIVirtualModelRulePanel_AIVirtualModelRulesListQuery = {
  response: addAIVirtualModelRulePanel_AIVirtualModelRulesListQuery$data;
  variables: addAIVirtualModelRulePanel_AIVirtualModelRulesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AIVirtualModelRuleInfoOutput",
    "kind": "LinkedField",
    "name": "aiVirtualModelRules",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ruleID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addAIVirtualModelRulePanel_AIVirtualModelRulesListQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addAIVirtualModelRulePanel_AIVirtualModelRulesListQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "3f19d2efe31678dfe70165ffa658fd21",
    "id": null,
    "metadata": {},
    "name": "addAIVirtualModelRulePanel_AIVirtualModelRulesListQuery",
    "operationKind": "query",
    "text": "query addAIVirtualModelRulePanel_AIVirtualModelRulesListQuery {\n  aiVirtualModelRules {\n    id\n    ruleID\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d79744b88229b32e850c9728663840e";

export default node;
